<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<sBox title="FILTRAR SOLICITAÇÕES">
					<template slot="tools">
						<aBtn
							text="Pesquisar"
							@click="updateTable"
							icon="search"
							size="sm"
							type="primary"
						/>
					</template>
					<template slot="body">
						<filter-exams ref="fExams" />
					</template>
				</sBox>
			</div>
			<div class="col-sm-12">
				<sBox title="GRID DE SOLICITAÇÕES">
					<div slot="tools">
						<aBtn
							@click="$refs.mdSol.open()"
							text="Solicitação"
							icon="plus"
							size="sm"
							type="success"
						/>
					</div>
					<div slot="body">
						<sTable
							ref="tabSol"
							actionRead="private-read-sd2000Solicitacoes"
							actionDelete="private-delete-sd2000DeleteSolicitacoes"
							:labels="labels"
							:actions="actions"
							:functions="functions"
							:tags="tags"
							:lineStatus="fxStatus"
							:block="true"
							@openManagerResults="
								(row) => $refs.mdResultExams.open(row)
							"
							@openCreateSol="(row) => $refs.mdSol.open(row)"
						/>
					</div>
				</sBox>
			</div>
		</div>
		<modal-solicitation ref="mdSol" @update="$refs.tabSol.updateTable()" />
		<md-result-exams ref="mdResultExams" />
	</div>
</template>
<script>
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import ModalSolicitation from './mdCreateSolicitation';
	import WBS from 'js/http';
	import gstDate from 'js/date';
	import mdResultExams from './mdExams';
	import filterExams from './components/filter.vue';
	const meses = [
		'Janeiro',
		'Fevereiro',
		'Março',
		'Abril',
		'Maio',
		'Junho',
		'Julho',
		'Agosto',
		'Setembro',
		'Outubro',
		'Novembro',
		'Dezembro',
	];

	export default {
		name: 'Sd2000Exames',
		components: {
			sTable,
			sBox,
			aBtn,
			ModalSolicitation,
			mdResultExams,
			filterExams,
		},
		data() {
			return {
				assets: {
					sd2000Tables: [],
					empresas: [],
					unidades: [],
					vetores: [],
				},
				labels: [
					{ data: 'cod', label: '#' },
					{
						data: ['matricula.mat', 'matricula.nome'],
						label: 'Colaborador',
						two: true,
					},
					{
						data: ['convocacao', 'coleta'],
						label: 'Convocação / Coleta',
						two: true,
					},
					{
						data: ['empresa', 'unidade'],
						label: 'Empresa / Unidade',
						two: true,
					},
					{ data: 'resultados', label: 'Tipo' },
				],
				functions: [
					{
						cod: 'convocacao',
						fx: (val) =>
							meses[parseInt(val.split('-')[1]) - 1] +
							' de ' +
							val.split('-')[0],
					}, // gstDate(`${val}-01`, 'xmlg de YY')  },
					{
						cod: 'coleta',
						fx: (val) => val.split('-').reverse().join('/'),
					},
					{
						cod: 'empresa',
						fx: (val) => this.getEmpUni(val, 'empresas'),
					},
					{
						cod: 'unidade',
						fx: (val) => this.getEmpUni(val, 'unidades'),
					},
					// { cod: 'exams', fx: val => val.length },
				],
				tags: [
					// {cod: 'operacao', value: 'I', html: 'Inclusão', color: 'info'},
					// {cod: 'operacao', value: 'A', html: 'Alteração', color: 'primary'},

					{
						cod: 'resultados',
						value: 'A',
						html: 'Admissional',
						color: 'success',
					},
					{
						cod: 'resultados',
						value: 'D',
						html: 'Demissional',
						color: 'danger',
					},
					{
						cod: 'resultados',
						value: 'P',
						html: 'Periódico',
						color: 'default',
					},
					{
						cod: 'resultados',
						value: 'E',
						html: 'Especial',
						color: 'warning',
					},
					{
						cod: 'resultados',
						value: 'M',
						html: 'Mudança de Função',
						color: 'warning',
					},
					{
						cod: 'resultados',
						value: 'R',
						html: 'Retorno ao Trabalho',
						color: 'info',
					},
					{
						cod: 'resultados',
						value: 'S',
						html: 'Supletiva',
						color: 'primary',
					},
				],
				actions: [
					'delete',
					// "edit",
					{
						emit: 'openManagerResults',
						color: 'btn-warning',
						icon: 'fa-edit',
						text: 'Resultados',
					},
					{
						emit: 'openCreateSol',
						color: 'btn-default',
						icon: 'fa-gears',
						text: '',
					},
				],
			};
		},
		provide() {
			let assets = {};
			for (let key in this.assets) {
				Object.defineProperty(assets, key, {
					enumerable: true,
					get: (e) => this.assets[key],
				});
			}
			return { assets: assets };
		},
		methods: {
			getEmpUni(val, type) {
				const index = this.assets[type].findIndex(
					(item) => item.cod == val
				);
				if (index != -1) return this.assets[type][index].title;
				return 'Indefinido';
			},
			fxStatus(val) {
				return val.pStatus;
			},
			import_tab_vector() {},
			updateTable() {
				const filter = this.$refs.fExams.filter();
				this.$refs.tabSol.setFilter(filter);
				this.$refs.tabSol.updateTable();
			},
		},
		mounted() {
			WBS.send('protected-read-sd2000Asstes', (resp) => {
				if (resp.status == 'success') {
					this.assets = resp.data;
					this.updateTable();
				}
			});
			this.$emit('setHeader', ['Solicitações', 'SD2000']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/solicitacoes/index.vue